export const PortletEndpoint = {
  ADD_NEW_PORTLET: '/default/portlet/add-new',
  REMOVE_PORTLET: '/default/portlet/delete',
  SHOW_ASYNC_PORTLET: '/default/portlet/show-async-portlet',
  SHOW_ASYNC_DYNAMIC_PORTLET: '/default/portlet/show-async-dynamic-portlet',
  UPDATE_CONFIGURATION: '/default/portlet/update-configuration',
  LOAD_CONFIGURATION: '/default/portlet/load-configuration',
  UPDATE_PORTLET_POSITION: '/default/portlet/update-one',
  LOAD_STATE: '/datatable-columns/load-state',
  SAVE_FILTER: '/datatable-columns/save-filter',
  SAVE_SORTING: '/datatable-columns/save-sorting',
};
